import { useCallback } from 'react';
import { useSupplierOfferItemAlternativeSubstituteDeleteMutation, useSupplierOfferItemDeleteMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useDeleteModal = (onDeleteModalClose: () => void, isSubTable?: boolean) => {
  const { handleError, handleSuccess } = useNotificationMessages();

  const [itemDelete, { isLoading }] = useSupplierOfferItemDeleteMutation();
  const [subItemDelete, { isLoading: subItemIsLoading }] = useSupplierOfferItemAlternativeSubstituteDeleteMutation();

  const onRemoveConfirm = useCallback(
    async (recordId: string | undefined) => {
      if (recordId) {
        try {
          const { data, error } = await (isSubTable ? subItemDelete : itemDelete)(recordId);
          if (data?.success) {
            handleSuccess('Supplier Offer Item was successfully deleted.');
            onDeleteModalClose();
          } else {
            handleError(error);
          }
        } catch (err) {
          handleError(err);
        }
      }
    },
    [itemDelete, subItemDelete, handleSuccess, onDeleteModalClose, handleError, isSubTable]
  );

  return {
    onRemoveConfirm,
    isLoading: isLoading || subItemIsLoading,
  };
};
